import React from 'react';
import { ChangeEvent } from 'react';
import { PalletDetail } from '../../../types/palletDetail';
import { DefectType } from '../../../types/defectType';
import { translateString } from '../../../translations/gridTranslationHelper';
import { Culture } from '../../../types/culture';
import ModalDefectsRow from '../../palstat/ModalDefectsRow';

interface ModalDefects2DefectsTableProps {
    pallets: PalletDetail[];
    defectTypes: DefectType[];
    addDefect: () => void;
    removeDefect: (defectId: string) => void;
    handleChange: (arg0: ChangeEvent, arg1: string) => void;
    defectAddImg: string;
    defectRemoveImg: string;
    culture: Culture;
}

const ModalDefects2DefectsTable: React.FC<ModalDefects2DefectsTableProps> = ({ pallets, defectTypes, addDefect, removeDefect, handleChange, defectAddImg, defectRemoveImg, culture }) => {
    const renderDefectRows = (pallets: PalletDetail[]) => {
        return pallets
            .map((pallet) => pallet.defects.map(d => ({...d, sequenceNo: pallet.sequenceNo, lot: pallet.lot, siteId: pallet.siteId}))
            .flat()
            .map((defect) => (
                <ModalDefectsRow
                    dataKey={defect.randomDefectId}
                    key={defect.randomDefectId}
                    defect={defect}
                    defectTypes={defectTypes}
                    addDefectFunc={addDefect}
                    removeDefectFunc={removeDefect}
                    handleChange={handleChange}
                    defectAddImg={defectAddImg}
                    defectRemoveImg={defectRemoveImg}
                    sequenceNo={defect.sequenceNo}
                    lot={defect.lot ?? ""}
                    siteId={defect.siteId}
                />
            )));
    };

    return (
        <table className="mt-1" style={{width: "100%"}}>
            <thead>
                <tr>
                    <th>SSCC</th>
                    <th>{translateString("defect", culture)}</th>
                    <th>{translateString("mouldNo", culture)}</th>
                    <th>{translateString("initials", culture)}</th>
                    <th>{translateString("comment", culture)}</th>
                    <th>
                        <img src={defectAddImg} alt="Add Defect" onClick={addDefect} />
                    </th>
                </tr>
            </thead>
            <tbody>
                {Array.isArray(pallets) ? renderDefectRows(pallets) : null}
            </tbody>
        </table>
    );
};

export default ModalDefects2DefectsTable;
